import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react'
import { userDataUpdate, loginStatusUpdate, expiryTokenMessageUpdate } from '../../../redux/user'   //buildNumberUpdate
//import { cycleIdUpdate } from '../../../modules/FinanceTable/redux/finance'
import apiservice from '../services/apiservices'
import '../static/css/login.css'

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: "",
            password: "",
            errorMessage: "",
            errorVisibility: "none",
            loadervisibility: "none",

            expiryTokenMessageVisibility: "none",
            expiryTokenMessage: "",
        }
        this.inputEmailBox = null
        this.inputPasswordBox = null
    }

    componentWillMount() {
        // this.getOrdersData()
    }

    componentDidMount() {
        this.inputEmailBox.focus()

        if(this.props.user && this.props.user.expiry_token_message) {
            this.setState({ expiryTokenMessageVisibility: "block", expiryTokenMessage: this.props.user.expiry_token_message })
        }
    }

    forgotPassword = () => {
        this.props.history.push("/forgotpasswordrequest")
    }

    resetErrorMessage = () => {
        this.setState({
            errorMessage: "",
            errorVisibility: "none",
            loadervisibility: "none",
        })
    }

    displayErrorMessage = (data = "", showError = false, showLoader = false) => {
        this.setState({
            errorMessage: data,
            errorVisibility: showError ? "block" : "none",
            loadervisibility: showLoader ? "block" : "none",
        })
    }
    onLogoClick = () => {
        window.open("https://app.hybb.in","'_blank'");
    }

    validateInputCredentials = (e) => {
        this.setState({ expiryTokenMessageVisibility: "none", expiryTokenMessage: "" })
        this.props.dispatch(expiryTokenMessageUpdate(""))
        
        if (this.inputEmailBox.value.length === 0) {
            this.inputEmailBox.focus()
            this.displayErrorMessage("Please enter credentials", true)
            this.refs.velocity.runAnimation()
            return
        }
        if (this.inputPasswordBox.value.length === 0) {
            this.inputPasswordBox.focus()
            this.displayErrorMessage("Please enter credentials", true)
            this.refs.velocity.runAnimation()
            return
        }

        this.displayErrorMessage("Loading", true, true)

        let data = {
            "username": this.inputEmailBox.value,
            "password": this.inputPasswordBox.value,
        }

        apiservice.loginAuthentication(data)
            .then(loginData => {
                this.props.dispatch(userDataUpdate(loginData))
                this.props.dispatch(loginStatusUpdate(true))
            })
            .catch(err => {
                console.log(err)
                this.displayErrorMessage("Credentials are wrong, Please enter proper credentials", true, false)
                this.refs.velocity.runAnimation()
            })
    }

    render() {
        let HBB_logo = require('../../../static/img/bbms-logo.png')
        let effect = "tada"
        let animation = 'callout.' + effect
        return (
            <div className="login_Page">
                <div className="login-page-box">
                    <VelocityComponent ref="velocity" key={effect} animation={animation} runOnMount={false}>
                        <div>
                            <div className="login-logo">
                                <img style={{ height: '60px', alignContent: 'center' }} alt="GMS logo"
                                    src={HBB_logo} onClick={this.onLogoClick} />
                            </div>
                            <input
                                className="login-input-box"
                                ref={e => this.inputEmailBox = e}
                                placeholder="E-Mail"
                                onChange={(e) => {
                                    this.resetErrorMessage()
                                }}
                                onKeyPress={(e) => {
                                    var code = (e.keyCode ? e.keyCode : e.which);
                                    if (code === 13) { //Enter keycode                        
                                        e.preventDefault()
                                        this.inputPasswordBox.focus()
                                    }
                                }}>
                            </input>
                            <input
                                className="login-input-box"
                                type="password"
                                ref={e => this.inputPasswordBox = e}
                                placeholder="Password"
                                onChange={(e) => {
                                    this.resetErrorMessage()
                                }}
                                onKeyPress={(e) => {
                                    var code = (e.keyCode ? e.keyCode : e.which);
                                    if (code === 13) { //Enter keycode                        
                                        e.preventDefault()
                                        this.validateInputCredentials(e)
                                    }
                                }}>
                            </input>
                            <button className="login-button-box"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.validateInputCredentials(e)
                                }}>
                                SIGN IN
                            </button>
                            <div className="forgot-password" style={{ display: 'block' }}
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.forgotPassword()
                                }}>
                                forgot password?
                            </div> 
                            <div
                                className="form-group has-error login-error-text"
                                style={{
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.loadervisibility,
                                }}>
                                <label className="control-label loader" style={{ fontSize: "15px" }} />
                            </div>
                            <div
                                className="form-group has-error login-error-text"
                                style={{
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.errorVisibility,
                                }}>
                                 <label className="control-label" style={{ fontSize: "15px" }} >
                                    {this.state.errorMessage}
                                 </label>
                            </div>
                            <div
                                className="form-group has-error login-error-text"
                                style={{
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.expiryTokenMessageVisibility,
                                }}>
                                 <label className="control-label" style={{ fontSize: "15px" }} >
                                    {this.state.expiryTokenMessage}
                                 </label>
                            </div>
                        </div>
                    </VelocityComponent>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(Login))


// WEBPACK FOOTER //
// ./src/modules/LoginPage/Components/Login.js